import React from 'react';
import { Link } from 'react-router-dom';
import { menuPage } from '@/data/content';
import useTopSellersData, { type TopSeller as TopSellerType } from '@/hooks/useTopSellersData';

const TopSeller: React.FC = () => {
    const { data: topSellers, isLoading, error } = useTopSellersData();

    if (isLoading || !topSellers || topSellers.length === 0) {
        return null;
    }

    return (
        <section className="py-2 border-b border-gray-100 dark:border-gray-800">
            <div className="max-w-5xl mx-auto px-4">
                <h2 className="text-xs font-semibold text-gray-500 dark:text-gray-400 mb-1.5">{menuPage.top_sellers_heading}</h2>
                <div className="flex flex-wrap gap-1.5">
                    {topSellers.slice(0, 8).map((food: TopSellerType, index: number) => (
                        <Link
                            key={food.id}
                            to={`/menu/${food.id}`}
                            className="text-[11px] font-medium text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-800 px-2 py-1 rounded hover:bg-orange-50 hover:text-app-primary transition-colors"
                        >
                            {food.item_name}
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TopSeller;
